import * as actionTypes from './actionTypes';
import { opportunityService } from './services';
import { fetchValidateAccess } from '@app/src/common/session';

const fetchOpportunityRequest = () => ({
  type: actionTypes.FETCH_OPPORTUNITY_REQUEST
});

const fetchOpportunitySuccess = (data) => ({
  type: actionTypes.FETCH_OPPORTUNITY_SUCCESS,
  data
});

const fetchOpportunityFailure = () => ({
  type: actionTypes.FETCH_OPPORTUNITY_FAILURE
});

const setOpportunityMessage = (message?: string) => ({
  type: actionTypes.SET_OPPORTUNITY_MESSAGE,
  message
})

export const clearOpportunityMessage = () => ({
  type: actionTypes.CLEAR_OPPORTUNITY_MESSAGE
})

export const clearOpportunityData = () => ({
  type: actionTypes.CLEAR_OPPORTUNITY_DATA
})

export const setOpportunitySelected = (selected: string) => ({
  type: actionTypes.SET_OPPORTUNITY_SELECTED,
  selected
})

export const clearOpportunitySelected = () => ({
  type: actionTypes.CLEAR_OPPORTUNITY_SELECTED
})

export const fetchOpportunity = (operation: number, packageId?: number): Function => {
  return async dispatch => {
    dispatch(fetchOpportunityRequest());
    try {
      let data = null;

      if (packageId) {
        data = await opportunityService.getConsume(operation, packageId);
      } else {
        await dispatch(fetchValidateAccess());
        data = await opportunityService.get(operation);
      }
      dispatch(fetchOpportunitySuccess(data));
      dispatch(setOpportunityMessage(data && data.length === 0 && 'No se encontraron resultados.'))
    } catch (e) {
      dispatch(fetchOpportunityFailure());
    }
  }
};
